import React from 'react';
import styled from 'styled-components';
import { Tabs, Theme } from '@lux/components-gomo';

const TabsContainer = styled.div`
  margin: ${Theme.spacing.medium} 0;
`;

const GomoTabs = props => {
  return (
    <TabsContainer>
      <Tabs {...props} />
    </TabsContainer>
  );
};

export default GomoTabs;
